import React from 'react'
import Navbar from '../LandingPage/Navbar/Navbar'
import Footer2 from '../Footer2/Footer2'
import OurCompany from '../Pages/OurCompany/OurCompany'
import TopBar from '../EdofSectionNew2/TopBar/TopBar'
const OurCompanyPage = () => {
    return (
        <div>
            <TopBar/>
            <Navbar />
            <OurCompany />
            <Footer2 />
        </div>
    )
}

export default OurCompanyPage
